var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { HEADER } from '@/stores/defs';
import { map, isString } from 'lodash';
var mixinName = {
    computed: __assign({}, mapGetters({
        _headerTitle: HEADER.GET_TITLE,
        _headerItems: HEADER.GET_ITEMS,
        _headerHeight: HEADER.GET_HEADER_HEIGHT,
    })),
    methods: __assign({}, mapActions({
        _setHeaderTitle: HEADER.SET_TITLE,
        _setHeaderItems: HEADER.SET_ITEMS,
        _setHeaderHeight: HEADER.SET_HEADER_HEIGHT,
    }), { _getItemsWithMap: function (itemMap) {
            var items = this._headerItems;
            return this._getItems(itemMap, items);
        },
        _getItems: function (itemMap, items) {
            return map(items, function (item) {
                var isItemKey = isString(item);
                var key = (isItemKey) ? item : item.key;
                var props = (isItemKey) ? null : item.props;
                return {
                    component: itemMap[key],
                    props: props,
                    id: key,
                };
            });
        },
        _adjustContainerForHeader: function (_a) {
            var padding = _a.padding;
            var _padding = padding | 0;
            var $el = this.$el;
            var height = +this._headerHeight;
            $el.style.paddingTop = height + _padding + "px";
        } }),
};
export default mixinName;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/headerMixin.ts
// module id = 26Qq
// module chunks = 18